import { render } from "./PositionsList.vue?vue&type=template&id=331c13dd&scoped=true"
import script from "./PositionsList.vue?vue&type=script&lang=js"
export * from "./PositionsList.vue?vue&type=script&lang=js"

import "./PositionsList.vue?vue&type=style&index=0&id=331c13dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331c13dd"]])

export default __exports__